import { computed } from 'vue';
import { usePermissions } from './usePermissions';

/**
 * Accès au module « Géniteurs externes ».
 * Même sécurité que « Gestion des Inscriptions » (rôles admin) MAIS sans
 * le cas « responsable haras public » (REPRESENTANT_HARAS_REGIONAL + haras PUBLIC).
 */
export function useGeniteursAccess() {
  const { hasRole } = usePermissions();

  const canAccessGeniteurs = computed(() =>
    hasRole(['SUPER_ADMIN', 'ADMIN', 'DIRECTEUR', 'CHEF_BUREAU'])
  );

  return { canAccessGeniteurs };
}
